<template>
    <vue-dropzone :id="id"
                  class="border-1 border-secondary rounded"
                  style="min-height: 0;"
                  :options="uploadOptions"
    />
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    components: {
        vueDropzone: vue2Dropzone
    },

    props: {
        id: {
            type: String,
            default: 'feed_uploader'
        },
        accept: String,
        multiple: Boolean,
        maxFiles: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            uploadOptions: {
                url: this.$route("stock-upload.store"),
                thumbnailHeight: 64,
                thumbnailWidth: 64,
                uploadMultiple: this.multiple,
                autoProcessQueue: false,
                addRemoveLinks: true,
                acceptedFiles: this.accept,
                maxFiles: this.maxFiles,
                dictDefaultMessage:
                    "<i class='fa fa-upload'></i> Drop file or click to select"
            }
        }
    }
}
</script>

<style>
.vue-dropzone > .dz-preview .dz-details {
    background-color: var(--primary) !important;
}
</style>
